/**
 * Accepts the pre-checked provider's name, adds a possessive suffix and then
 * returns the modal title
 *
 * @param noSwipe - Boolean indicating if this is a no-swipe provider
 * @param providerName - Name of the provider
 * @returns Formatted modal title
 */
export const getModalTitle = (
  noSwipe: boolean,
  providerName: string,
): string => {
  if (noSwipe) {
    return `Learn more about ${providerName}`
  }

  const lastChar = providerName.charAt(providerName.length - 1).toLowerCase()
  const possessiveName =
    lastChar === 's' ? providerName + `\u2019` : providerName + `${`\u2019`}s`

  return `Visit ${possessiveName} website`
}
